import React from 'react'
import ReactDom from 'react-dom'
import Card from './Cards'
import Sdata from './Sdata'
import "./index.css"
import App from './App.jsx'

ReactDom.render(
 <App/>
  , document.getElementById('root'));

/*
normal function
function myname(val){

}

fat arrow function
const ncard = (val)=>{

return(
  <Card
   imgsrc={val.imgsrc}
  title={val.title}
  sname={val.sname}
  link={val.links
  }   />
);
}


*/